import React from 'react';
import { Link } from 'react-router-dom';
import {
  ButtonsContainer,
  LeftButtonWrapper,
  ButtonWrapper,
  LeftButton,
  FixedButton
} from './styles';

function MobileDoubleButtons({ firstLabel, secondLabel, firstAddress, secondAddress }) {
  return (
    <ButtonsContainer>
      <LeftButtonWrapper>
        <LeftButton
          color="secondary"
          aria-label="Add"
          variant="contained"
          component={Link}
          to={firstAddress}
        >
          {firstLabel}
        </LeftButton>
      </LeftButtonWrapper>
      <ButtonWrapper>
        <FixedButton
          color="secondary"
          aria-label="Add"
          variant="contained"
          component={Link}
          to={secondAddress}
        >
          {secondLabel}
        </FixedButton>
      </ButtonWrapper>
    </ButtonsContainer>
  );
}

export default MobileDoubleButtons;
